import { Directive, HostListener, OnInit, OnDestroy } from '@angular/core';
import * as screenfull from 'screenfull';
import { Screenfull } from 'screenfull';

@Directive({
  selector: '[toggleFullscreen]'
})
export class ToggleFullscreenDirective implements OnInit, OnDestroy {

  private sf = screenfull as Screenfull;

  private isAnsweringPage(): boolean {
    return window.location.href.includes('studentlogin/answering');
  }

  ngOnInit() {
    if (this.sf.isEnabled) {
      this.sf.on('change', this.onFullscreenChange);
    }
  }

  ngOnDestroy() {
    if (this.sf.isEnabled) {
      this.sf.off('change', this.onFullscreenChange);
    }
  }

  private onFullscreenChange = () => {
    if (!this.sf.isFullscreen && this.isAnsweringPage()) {
      console.warn('Fullscreen exited – forcing back');
    }
  }

  // @HostListener('window:keydown', ['$event'])
  // handleKeydown(event: KeyboardEvent) {
  //   console.log(event, 'keydown')
  //   if ((event.key === 'Escape' || event.key == 'Alt') && this.isAnsweringPage()) {
  //     setTimeout(() => this.sf.request(), 1000);
  //   }
  // }

  @HostListener('click')
  onClick() {
    if (this.sf.isEnabled) {
      this.sf.toggle();
      console.log('serbcc')
      // if (!this.sf.isFullscreen && this.isAnsweringPage()) {
      //   setTimeout(() => this.sf.request(), 1000);
      // } else {
      // }
    }
  }
}
